import { scientificLabel } from '@/lib/catalogSearch';

// Discovery aid only: authors and typography do not define different species.
// Use documented names; never infer synonymy from a shared common name.
export function botanicalNameKey(value) {
  const text = String(value || '').replace(/×/g, ' ').replace(/\s+/g, ' ').trim();
  const match = text.match(/^([A-Z][a-z]+)\s+([a-z][a-z-]*)\b/);
  if (!match || ['sp', 'spp'].includes(match[2])) return '';
  const rank = text.match(/\b(subsp\.|ssp\.?|var\.|f\.)\s+([a-z][a-z-]*)/);
  return `${match[1]} ${match[2]}${rank ? ` ${rank[1].startsWith('s') ? 'subsp.' : rank[1]} ${rank[2]}` : ''}`.toLowerCase();
}
export function cropMatchesTaxon(crop, species) {
  if (!crop || !species) return false;
  const key = botanicalNameKey(scientificLabel(crop));
  if (!key) return false;
  return [species.accepted_name, species.scientific_name, ...(species.verified_synonyms || [])]
    .some(name => botanicalNameKey(name) === key);
}
